import { globals, page as pageIndex } from "../../globals";
import { showModal } from "./modal";
import { clearHistory, saveInitialValues } from "./undo";
import { UPDATE_DATA, actionHandler } from "./updateData";

// ------------------------------------
// Constants
// ------------------------------------
export const GET_GROUPS_START = "GET_GROUPS_START";
export const GET_GROUPS_FETCHED = "GET_GROUPS_FETCHED";
export const GET_CLIENT_SUBJECTS = "GET_CLIENT_SUBJECTS";
export const GET_CLIENT_SUBJECTS_FETCHED = "GET_CLIENT_SUBJECTS_FETCHED";
export const UPDATE_KEYWORDS_DATA = "UPDATE_KEYWORDS_DATA";
export const GET_GROUPING_LIST_START = "GET_GROUPING_LIST_START";
export const GET_GROUPING_LIST_SUCCESS = "GET_GROUPING_LIST_SUCCESS";
export const GET_GROUPING_LIST_FAILURE = "GET_GROUPING_LIST_FAILURE";
export const GET_GROUPING_START = "GET_GROUPING_START";
export const GET_GROUPING_SUCCESS = "GET_GROUPING_SUCCESS";
export const GET_GROUPING_FAILURE = "GET_GROUPING_FAILURE";
export const GET_CLIENT_SUBJECT_INFO_START = "GET_CLIENT_SUBJECT_INFO_START";
export const GET_CLIENT_SUBJECT_INFO_SUCCESS =
  "GET_CLIENT_SUBJECT_INFO_SUCCESS";
export const GET_CLIENT_SUBJECT_INFO_FAILURE =
  "GET_CLIENT_SUBJECT_INFO_FAILURE";
export const CLEAR_GROUPING_SEARCH_DATA = "CLEAR_GROUPING_SEARCH_DATA";
export const PUT_GROUPING_START = "PUT_GROUPING_START";
export const PUT_GROUPING_SUCCESS = "PUT_GROUPING_SUCCESS";
export const PUT_GROUPING_FAILURE = "PUT_GROUPING_FAILURE";
export const GET_MAIN_GROUPING_START = "GET_MAIN_GROUPING_START";
export const GET_MAIN_GROUPING_SUCCESS = "GET_MAIN_GROUPING_SUCCESS";
export const GET_MAIN_GROUPING_FAILURE = "GET_MAIN_GROUPING_FAILURE";
export const DELETE_MAIN_GROUPING_START = "DELETE_MAIN_GROUPING_START";
export const DELETE_MAIN_GROUPING_SUCCESS = "DELETE_MAIN_GROUPING_SUCCESS";
export const DELETE_MAIN_GROUPING_FAILURE = "DELETE_MAIN_GROUPING_FAILURE";
export const DELETE_SUBJECT_GROUPING_START = "DELETE_SUBJECT_GROUPING_START";
export const DELETE_SUBJECT_GROUPING_SUCCESS =
  "DELETE_SUBJECT_GROUPING_SUCCESS";
export const DELETE_SUBJECT_GROUPING_FAILURE =
  "DELETE_SUBJECT_GROUPING_FAILURE";
export const POST_MAIN_GROUPING_START = "POST_MAIN_GROUPING_START";
export const POST_MAIN_GROUPING_SUCCESS = "POST_MAIN_GROUPING_SUCCESS";
export const POST_MAIN_GROUPING_FAILURE = "POST_MAIN_GROUPING_FAILURE";
export const GET_SUBJECT_GROUPINGS_START = "GET_SUBJECT_GROUPINGS_START";
export const GET_SUBJECT_GROUPINGS_SUCCESS = "GET_SUBJECT_GROUPINGS_SUCCESS";
export const GET_SUBJECT_GROUPINGS_FAILURE = "GET_SUBJECT_GROUPINGS_FAILURE";
export const PUT_MAIN_GROUP_SUBJECT_GROUP_START =
  "PUT_MAIN_GROUP_SUBJECT_GROUP_START";
export const PUT_MAIN_GROUP_SUBJECT_GROUP_SUCCESS =
  "PUT_MAIN_GROUP_SUBJECT_GROUP_SUCCESS";
export const PUT_MAIN_GROUP_SUBJECT_GROUP_FAILURE =
  "PUT_MAIN_GROUP_SUBJECT_GROUP_FAILURE";
export const POST_SUBJECT_GROUPING_START = "POST_SUBJECT_GROUPING_START";
export const POST_SUBJECT_GROUPING_SUCCESS = "POST_SUBJECT_GROUPING_SUCCESS";
export const POST_SUBJECT_GROUPING_FAILURE = "POST_SUBJECT_GROUPING_FAILURE";
export const GET_CLIENTS_START = "GET_CLIENTS_START";
export const GET_CLIENTS_SUCCESS = "GET_CLIENTS_SUCCESS";
export const GET_CLIENTS_FAILURE = "GET_CLIENTS_FAILURE";
export const GET_SUBJECTS_START = "GET_SUBJECTS_START";
export const GET_SUBJECTS_SUCCESS = "GET_SUBJECTS_SUCCESS";
export const GET_SUBJECTS_FAILURE = "GET_SUBJECTS_FAILURE";
export const PUT_SUBJECT_GROUPING_SUBJECTS_START =
  "PUT_SUBJECT_GROUPING_SUBJECTS_START";
export const PUT_SUBJECT_GROUPING_SUBJECTS_SUCCESS =
  "PUT_SUBJECT_GROUPING_SUBJECTS_SUCCESS";
export const PUT_SUBJECT_GROUPING_SUBJECTS_FAILURE =
  "PUT_SUBJECT_GROUPING_SUBJECTS_FAILURE";
export const GET_SUBJECT_GROUPING_START = "GET_SUBJECT_GROUPING_START";
export const GET_SUBJECT_GROUPING_SUCCESS = "GET_SUBJECT_GROUPING_SUCCESS";
export const GET_SUBJECT_GROUPING_FAILURE = "GET_SUBJECT_GROUPING_FAILURE";
export const PUT_SUBJECT_GROUPING_START = "PUT_SUBJECT_GROUPING_START";
export const PUT_SUBJECT_GROUPING_SUCCESS = "PUT_SUBJECT_GROUPING_SUCCESS";
export const PUT_SUBJECT_GROUPING_FAILURE = "PUT_SUBJECT_GROUPING_FAILURE";
export const POST_CLIENT_SUBJECT_TAG_START = "POST_CLIENT_SUBJECT_TAG_START";
export const POST_CLIENT_SUBJECT_TAG_SUCCESS =
  "POST_CLIENT_SUBJECT_TAG_SUCCESS";
export const POST_CLIENT_SUBJECT_TAG_FAILURE =
  "POST_CLIENT_SUBJECT_TAG_FAILURE";

const headers = {
  "Content-Type": "application/json",
};

function matchGroupingListRecords(groupingsJson) {
  return groupingsJson.map((mainGroupings) => {
    return {
      groupId: mainGroupings.MainGroupingId,
      groupName: mainGroupings.MainGroupingName,
      subjects: mainGroupings.SubjectGroupings.map((subjectGrouping) => {
        return {
          subjectId: subjectGrouping.GroupingId,
          subjectName: subjectGrouping.GroupingName,
          parentId: mainGroupings.MainGroupingId,
          team: subjectGrouping.Team,
        };
      }),
    };
  });
}

function matchGroupingRecord(groupingJson) {
  return {
    taggingInstructions:
      groupingJson.TaggingInstructions ||
      groupingJson.taggingInstructions ||
      "",
    groupingDescription:
      groupingJson.Description || groupingJson.groupingDescription || "",
    overview: groupingJson.Overview || groupingJson.overview || "",
    teams: groupingJson.Teams || groupingJson.teams || [],
    groupingId: groupingJson.GroupingId || groupingJson.groupingId,
    groupingName: groupingJson.GroupingName || groupingJson.groupingName || "",
  };
}

function matchClientSubjects(clientSubjectJson) {
  return clientSubjectJson.map((clientSubject, index) => {
    return {
      index,
      subjectId: clientSubject.IssueId,
      client: clientSubject.ClientName,
      clientSubject: clientSubject.Subject,
      notInState: !clientSubject.Enabled,
      coverage: clientSubject.Coverage,
    };
  });
}

function matchKeywordRows(groupingKeywords) {
  return groupingKeywords.map((groupingKeyword, index) => {
    const coverage = [];
    if (groupingKeyword.StateLegis) {
      coverage.push("legis");
    }
    if (groupingKeyword.FedLegis) {
      coverage.push("fed");
    }
    if (groupingKeyword.StateReg) {
      coverage.push("regs");
    }
    if (groupingKeyword.FedReg) {
      coverage.push("fedR");
    }

    return {
      keywordId: groupingKeyword.KeywordId,
      team: groupingKeyword.Team,
      keyword: groupingKeyword.Keyword,
      boolean: groupingKeyword.BoolPhrase,
      lastEdit: groupingKeyword.LastEditDate,
      lastEditor: groupingKeyword.LastEditUser,
      coverage,
    };
  });
}

export function updateKeywords(location, valueType, valueID, fieldValue) {
  return {
    type: UPDATE_KEYWORDS_DATA,
    location,
    valueType,
    payload: {
      value: valueID,
      fieldValue: fieldValue,
    },
  };
}

export function getGroupingList(
  teams,
  serviceType,
  countryCode,
  searchTerm,
  searchFields,
  subjectFilter,
  state,
  location
) {
  return (dispatch) => {
    dispatch({ type: GET_GROUPING_LIST_START });

    const options = {
      method: "GET",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/GroupingList`);

    const params = {
      serviceType,
      countryCode,
      searchTerm,
      state,
      location,
    };

    if (Object.keys(params)) {
      Object.keys(params).forEach((key) => {
        if (params[key]) {
          url.searchParams.append(key, params[key]);
        }
      });
    }

    if (teams && teams.length != 0) {
      teams.forEach((team) => url.searchParams.append("teamId", team));
    }

    if (searchFields && searchFields.length != 0) {
      searchFields.forEach((searchField) =>
        url.searchParams.append("searchField", searchField)
      );
    }

    return fetch(url, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 404 ||
          response.status === 500
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: GET_GROUPING_LIST_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          var filteredJson = json;
          if (subjectFilter) {
            filteredJson = json.slice(0, 1);
            filteredJson[0] = {
              ...filteredJson[0],
              SubjectGroupings: filteredJson[0].SubjectGroupings.filter(
                (subjectGrouping) =>
                  subjectGrouping.GroupingId === subjectFilter
              ),
            };
          }
          dispatch({
            type: GET_GROUPING_LIST_SUCCESS,
            payload: {
              filteredJson,
            },
          });
          return filteredJson;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_GROUPING_LIST_FAILURE, json: err.message });
      });
  };
}

export function clearSearchData() {
  return {
    type: CLEAR_GROUPING_SEARCH_DATA,
  };
}

export function getGrouping(
  groupId,
  groupingsType,
  groupingsService,
  state,
  location
) {
  return (dispatch) => {
    dispatch({ type: GET_GROUPING_START });

    const options = {
      method: "GET",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/Grouping`);

    const params = {
      groupingId: groupId,
      serviceType: groupingsType,
      regsService: groupingsService,
      state,
      location
    };

    if (Object.keys(params)) {
      Object.keys(params).forEach((key) => {
        if (params[key]) {
          url.searchParams.append(key, params[key]);
        }
      });
    }

    return fetch(url, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 404 ||
          response.status === 500
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: GET_GROUPING_FAILURE, json: text });
              dispatch(showModal("Error", { errorMessage: text }));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_GROUPING_SUCCESS,
            payload: {
              json,
            },
          });
          dispatch(clearHistory(pageIndex.groupings));
          dispatch(
            saveInitialValues(pageIndex.groupings, {
              selectedGroupSubjectInfo: {
                textValues: matchGroupingRecord(json.GroupInfo),
              },
            })
          );
          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_GROUPING_FAILURE, json: err.message });
      });
  };
}

export function putGrouping(selectedGroupSubjectInfo) {
  return (dispatch) => {
    dispatch({ type: PUT_GROUPING_START });

    const parameters = {
      groupingId: selectedGroupSubjectInfo.groupingId,
      description: selectedGroupSubjectInfo.groupingDescription,
      taggingInstructions: selectedGroupSubjectInfo.taggingInstructions,
      overview: selectedGroupSubjectInfo.overview,
    };

    const options = {
      method: "PUT",
      credentials: "include",
      headers,
      body: JSON.stringify(parameters),
    };

    const url = new URL(`${globals.apiUrl}/Grouping`);

    return fetch(url, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 404 ||
          response.status === 500
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: PUT_GROUPING_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: PUT_GROUPING_SUCCESS,
            payload: {
              json,
            },
          });
          dispatch(clearHistory(pageIndex.groupings));
          dispatch(
            saveInitialValues(pageIndex.groupings, {
              selectedGroupSubjectInfo: {
                textValues: matchGroupingRecord(selectedGroupSubjectInfo, json),
              },
            })
          );
          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: PUT_GROUPING_FAILURE, json: err.message });
      });
  };
}

export function getClientSubjectInfo(issueId, clientName) {
  return (dispatch) => {
    dispatch({ type: GET_CLIENT_SUBJECT_INFO_START });

    const options = {
      method: "GET",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/clientsubject`);

    const params = {
      issueid: issueId,
      clientname: clientName,
    };

    if (Object.keys(params)) {
      Object.keys(params).forEach((key) => {
        if (params[key]) {
          url.searchParams.append(key, params[key]);
        }
      });
    }

    return fetch(url, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 404 ||
          response.status === 500
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: GET_CLIENT_SUBJECT_INFO_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_CLIENT_SUBJECT_INFO_SUCCESS,
            payload: {
              json,
            },
          });
          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_CLIENT_SUBJECT_INFO_FAILURE, json: err.message });
      });
  };
}

export function getMainGroupings() {
  return (dispatch) => {
    dispatch({ type: GET_MAIN_GROUPING_START });

    const options = {
      method: "GET",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/MainGrouping`);

    return fetch(url, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 404 ||
          response.status === 500
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: GET_MAIN_GROUPING_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_MAIN_GROUPING_SUCCESS,
            payload: {
              json,
            },
          });
          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_MAIN_GROUPING_FAILURE, json: err.message });
      });
  };
}

export function deleteMainGrouping(mainGroupingId) {
  return (dispatch) => {
    dispatch({ type: DELETE_MAIN_GROUPING_START });

    const options = {
      method: "DELETE",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/MainGrouping/${mainGroupingId}`);

    return fetch(url, options)
      .then((response) => {
        if (response.status === 204 || response.status === 200) {
          dispatch({
            type: DELETE_MAIN_GROUPING_SUCCESS,
            payload: {
              mainGroupingId,
            },
          });
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 404 ||
          response.status === 409 ||
          response.status === 500
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: DELETE_MAIN_GROUPING_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: DELETE_MAIN_GROUPING_FAILURE, json: err.message });
      });
  };
}

export function postMainGrouping(mainGroupingName) {
  return (dispatch) => {
    dispatch({ type: POST_MAIN_GROUPING_START });

    let formData = new FormData();
    formData.append("mainGroupName", mainGroupingName);

    const options = {
      method: "POST",
      credentials: "include",
      body: formData,
    };

    const url = new URL(`${globals.apiUrl}/MainGrouping`);

    return fetch(url, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 404 ||
          response.status === 409 ||
          response.status === 500
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: POST_MAIN_GROUPING_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: POST_MAIN_GROUPING_SUCCESS,
            payload: {
              json,
            },
          });
          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: POST_MAIN_GROUPING_FAILURE, json: err.message });
      });
  };
}

export function postClientSubjectTag(clientSubjectTags) {
  return (dispatch) => {
    dispatch({ type: POST_CLIENT_SUBJECT_TAG_START });

    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: JSON.stringify(clientSubjectTags),
    };

    const url = new URL(`${globals.apiUrl}/ClientSubjectTag`);

    return fetch(url, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 404 ||
          response.status === 409 ||
          response.status === 500
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: POST_CLIENT_SUBJECT_TAG_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: POST_CLIENT_SUBJECT_TAG_SUCCESS,
            payload: {
              json,
            },
          });
          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: POST_CLIENT_SUBJECT_TAG_FAILURE, json: err.message });
      });
  };
}

export function getSubjectGroupings(
  mainGroupingId,
  linked = null,
  filterData = null
) {
  return (dispatch) => {
    dispatch({ type: GET_SUBJECT_GROUPINGS_START });

    const options = {
      method: "GET",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/subjectgrouping`);

    if (mainGroupingId) {
      url.searchParams.append("mainGroupId", mainGroupingId);
    }

    if (linked !== null) {
      url.searchParams.append("linked", linked);
    }

    if (!linked && filterData) {
      url.searchParams.append("teamId", filterData.selectedTeams);
      url.searchParams.append("serviceType", filterData.groupingsType);
      url.searchParams.append("countryCode", filterData.groupingsCountry);
    }

    const searchData = filterData ? filterData.searchData : null;

    if (searchData) {
      url.searchParams.append(
        "searchTerm",
        encodeURIComponent(searchData.term)
      );

      const searchFields = searchData.fields;

      if (searchFields && searchFields.length != 0) {
        searchFields.forEach((searchField) =>
          url.searchParams.append("searchField", searchField)
        );
      }
    }

    return fetch(url, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 404 ||
          response.status === 500
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: GET_SUBJECT_GROUPINGS_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_SUBJECT_GROUPINGS_SUCCESS,
            payload: {
              json,
            },
          });
          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_SUBJECT_GROUPINGS_FAILURE, json: err.message });
      });
  };
}

export function putMainGroupSubjectGroup(updatingGrouping, subjectGroupings) {
  return (dispatch) => {
    dispatch({ type: PUT_MAIN_GROUP_SUBJECT_GROUP_START });

    const parameters = {
      mainGroupingId: updatingGrouping.MainGroupingId,
      mainGroupingName: updatingGrouping.MainGroupingName,
      subjectGroupings: subjectGroupings,
    };

    const options = {
      method: "PUT",
      credentials: "include",
      headers,
      body: JSON.stringify(parameters),
    };

    const url = new URL(`${globals.apiUrl}/MainGroupSubjectGroup`);

    return fetch(url, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 404 ||
          response.status === 500
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: PUT_MAIN_GROUP_SUBJECT_GROUP_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: PUT_MAIN_GROUP_SUBJECT_GROUP_SUCCESS,
            payload: {
              json,
            },
          });
          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: PUT_MAIN_GROUP_SUBJECT_GROUP_FAILURE,
          json: err.message,
        });
      });
  };
}

export function getSubjectGrouping(subjectGroupingId) {
  return (dispatch) => {
    dispatch({ type: GET_SUBJECT_GROUPING_START });

    const options = {
      method: "GET",
      credentials: "include",
    };

    const url = new URL(
      `${globals.apiUrl}/SubjectGrouping/${subjectGroupingId}`
    );

    return fetch(url, options)
      .then((response) => {
        if (response.status === 204 || response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 404 ||
          response.status === 401 ||
          response.status === 500
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: GET_SUBJECT_GROUPING_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_SUBJECT_GROUPING_FAILURE, json: err.message });
      });
  };
}

export function deleteSubjectGrouping(subjectGroupingId) {
  return (dispatch) => {
    dispatch({ type: DELETE_SUBJECT_GROUPING_START });

    const options = {
      method: "DELETE",
      credentials: "include",
    };

    const url = new URL(
      `${globals.apiUrl}/SubjectGrouping/${subjectGroupingId}`
    );

    return fetch(url, options)
      .then((response) => {
        if (response.status === 204 || response.status === 200) {
          dispatch({
            type: DELETE_SUBJECT_GROUPING_SUCCESS,
            payload: {
              subjectGroupingId,
            },
          });
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 403 ||
          response.status === 404 ||
          response.status === 409 ||
          response.status === 500
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: DELETE_SUBJECT_GROUPING_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: DELETE_SUBJECT_GROUPING_FAILURE, json: err.message });
      });
  };
}

export function postSubjectGrouping(subjectGroupName, teams) {
  return (dispatch) => {
    dispatch({ type: POST_SUBJECT_GROUPING_START });

    const parameters = {
      subjectGroupName,
      teams,
    };

    let formData = new FormData();
    formData.append("subjectGroupName", subjectGroupName);
    formData.append("teams", teams.join(","));

    const options = {
      method: "POST",
      credentials: "include",
      body: formData,
    };

    const url = new URL(`${globals.apiUrl}/SubjectGrouping`);

    return fetch(url, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 404 ||
          response.status === 409 ||
          response.status === 500
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: POST_SUBJECT_GROUPING_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: POST_SUBJECT_GROUPING_SUCCESS,
            payload: {
              json,
            },
          });
          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: POST_SUBJECT_GROUPING_FAILURE, json: err.message });
      });
  };
}

export function getClients(stateName, locality) {
  return (dispatch) => {
    dispatch({ type: GET_CLIENTS_START });

    const options = {
      method: "GET",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/client`);

    const params = {
      active: true,
      searchtype: "all",
      servicelevel: "analystfiltered",
    };

    if (stateName) params.stateName = stateName;

    if (locality) params.locality = locality;

    if (Object.keys(params)) {
      Object.keys(params).forEach((key) => {
        if (params[key]) {
          url.searchParams.append(key, params[key]);
        }
      });
    }

    return fetch(url, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 404 ||
          response.status === 500
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: GET_CLIENTS_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_CLIENTS_SUCCESS,
            payload: {
              json,
            },
          });
          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_CLIENTS_FAILURE, json: err.message });
      });
  };
}

export function getSubjects(client, dataType, stateName) {
  return (dispatch) => {
    dispatch({ type: GET_SUBJECTS_START });

    const options = {
      method: "GET",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/ClientSubject/${client}`);

    const params = {
      dataType,
      stateName,
    };

    if (Object.keys(params)) {
      Object.keys(params).forEach((key) => {
        if (params[key]) {
          url.searchParams.append(key, params[key]);
        }
      });
    }

    return fetch(url, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 404 ||
          response.status === 500
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: GET_SUBJECTS_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_SUBJECTS_SUCCESS,
            payload: {
              json,
            },
          });
          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_SUBJECTS_FAILURE, json: err.message });
      });
  };
}

export function putSubjectGroupSubjects(
  updatingSubjectGrouping,
  clientSubjects
) {
  return (dispatch) => {
    dispatch({ type: PUT_SUBJECT_GROUPING_SUBJECTS_START });

    const parameters = {
      groupingId: updatingSubjectGrouping.GroupingId,
      subjects: clientSubjects.map((clientSubject) => {
        return {
          groupingId: updatingSubjectGrouping.GroupingId,
          client: clientSubject.client.Name,
          issueId: clientSubject.subject.IssueId,
          ...(clientSubject.legis.visible && {
            legisSelected: clientSubject.legis.selected,
          }),
          ...(clientSubject.regs.visible && {
            regsSelected: clientSubject.regs.selected,
          }),
          ...(clientSubject.local.visible && {
            localSelected: clientSubject.local.selected,
          }),
        };
      }),
    };

    const options = {
      method: "PUT",
      credentials: "include",
      headers,
      body: JSON.stringify(parameters),
    };

    const url = new URL(`${globals.apiUrl}/SubjectGroupSubject`);

    return fetch(url, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 415 ||
          response.status === 404 ||
          response.status === 500
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: PUT_SUBJECT_GROUPING_SUBJECTS_FAILURE,
                json: text,
              });
              console.log(text);
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: PUT_SUBJECT_GROUPING_SUBJECTS_SUCCESS,
            payload: {
              json,
            },
          });
          return json.Subjects;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: PUT_SUBJECT_GROUPING_SUBJECTS_FAILURE,
          json: err.message,
        });
      });
  };
}

export function putSubjectGrouping(
  subjectGroupingId,
  subjectGroupingName,
  teams
) {
  return (dispatch) => {
    dispatch({ type: PUT_SUBJECT_GROUPING_START });

    let formData = new FormData();
    formData.append("subjectGroupName", subjectGroupingName);
    formData.append("teams", teams);

    const options = {
      method: "PUT",
      credentials: "include",
      body: formData,
    };

    const url = new URL(
      `${globals.apiUrl}/SubjectGrouping/${subjectGroupingId}`
    );

    return fetch(url, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 404 ||
          response.status === 500
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: PUT_SUBJECT_GROUPING_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: PUT_SUBJECT_GROUPING_SUCCESS,
            payload: {
              json,
            },
          });

          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: PUT_SUBJECT_GROUPING_FAILURE, json: err.message });
      });
  };
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [UPDATE_DATA]: (state, action) =>
    action.location.page !== pageIndex.groupings
      ? state
      : actionHandler(state, action),
  [CLEAR_GROUPING_SEARCH_DATA]: (state) => {
    return {
      ...state,
      formDataValue: {
        G: {
          ...state.formDataValue.G,
          searchGroupings: {
            textValues: { searchInput: "" },
            selected: [],
          },
        },
      },
    };
  },
  [GET_GROUPING_LIST_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [GET_GROUPING_LIST_SUCCESS]: (state, action) => {
    const { filteredJson } = action.payload;
    const matchedGroups = matchGroupingListRecords(filteredJson);

    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        groups: matchedGroups,
      },
    };
  },
  [GET_GROUPING_LIST_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,

      renderData: {
        ...state.renderData,
        groups: [],
      },
    };
  },
  [GET_GROUPING_START]: (state) => {
    return {
      ...state,
      isFetchingData: false,
    };
  },
  [GET_GROUPING_SUCCESS]: (state, action) => {
    const { json } = action.payload;
    const clientSubjects = matchClientSubjects(json.ClientSubjects);
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        clientSubjects: clientSubjects,
      },
      formDataValue: {
        G: {
          ...state.formDataValue.G,
          keywordRows: matchKeywordRows(json.GroupingKeywords),
          selectedGroupSubjectInfo: {
            textValues: matchGroupingRecord(json.GroupInfo),
          },
        },
      },
    };
  },
  [PUT_GROUPING_SUCCESS]: (state, action) => {
    const { json } = action.payload;
    return {
      ...state,
      formDataValue: {
        G: {
          ...state.formDataValue.G,
          selectedGroupSubjectInfo: {
            textValues: matchGroupingRecord(json),
          },
        },
      },
    };
  },
  [POST_MAIN_GROUPING_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
    };
  },
  [PUT_GROUPING_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
    };
  },
  [POST_CLIENT_SUBJECT_TAG_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
    };
  },
  [GET_CLIENT_SUBJECT_INFO_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
    };
  },
  [GET_GROUPING_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
    };
  },
  [GET_MAIN_GROUPING_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingMainGroupings: false,
    };
  },
  [GET_SUBJECT_GROUPINGS_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingSubjectGroupings: false,
    };
  },
  [PUT_MAIN_GROUP_SUBJECT_GROUP_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
    };
  },
  [GET_SUBJECT_GROUPING_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
    };
  },
  [GET_CLIENT_SUBJECTS_FETCHED]: (state, action) => {
    const { json } = action.payload;
    return {
      ...state,
      renderData: {
        ...state.renderData,
        clientSubjects: json,
      },
    };
  },
  [GET_MAIN_GROUPING_START]: (state) => {
    return {
      ...state,
      isFetchingMainGroupings: true,
    };
  },
  [GET_MAIN_GROUPING_SUCCESS]: (state, action) => {
    const { json } = action.payload;
    return {
      ...state,
      isFetchingMainGroupings: false,
      renderData: {
        ...state.renderData,
        mainGroupings: json,
      },
    };
  },
  [DELETE_MAIN_GROUPING_SUCCESS]: (state, action) => {
    const { mainGroupingId } = action.payload;
    return {
      ...state,
      renderData: {
        ...state.renderData,
        mainGroupings: state.renderData.mainGroupings.filter(
          (mainGrouping) => mainGrouping.MainGroupingId !== mainGroupingId
        ),
      },
    };
  },
  [DELETE_MAIN_GROUPING_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
    };
  },
  [DELETE_SUBJECT_GROUPING_SUCCESS]: (state, action) => {
    const { subjectGroupingId } = action.payload;
    return {
      ...state,
      renderData: {
        ...state.renderData,
        subjectGroupings: state.renderData.subjectGroupings.filter(
          (subjectGrouping) => subjectGrouping.GroupingId !== subjectGroupingId
        ),
      },
    };
  },
  [DELETE_SUBJECT_GROUPING_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
    };
  },
  [POST_SUBJECT_GROUPING_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
    };
  },
  [GET_CLIENTS_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
    };
  },
  [GET_SUBJECTS_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
    };
  },
  [PUT_SUBJECT_GROUPING_SUBJECTS_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
    };
  },
  [PUT_SUBJECT_GROUPING_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
    };
  },
  [POST_MAIN_GROUPING_SUCCESS]: (state, action) => {
    const { json } = action.payload;
    return {
      ...state,
      renderData: {
        ...state.renderData,
        mainGroupings: [json, ...state.renderData.mainGroupings],
      },
    };
  },
  [POST_SUBJECT_GROUPING_SUCCESS]: (state, action) => {
    const { json } = action.payload;
    const subjectGrouping = { ...json, IssueCount: 0 };

    return {
      ...state,
      renderData: {
        ...state.renderData,
        subjectGroupings: [
          subjectGrouping,
          ...state.renderData.subjectGroupings,
        ],
      },
    };
  },
  [GET_SUBJECT_GROUPINGS_START]: (state) => {
    return {
      ...state,
      isFetchingSubjectGroupings: true,
      renderData: {
        ...state.renderData,
        selectableSubjectGrouping: [],
      },
    };
  },
  [PUT_MAIN_GROUP_SUBJECT_GROUP_SUCCESS]: (state, action) => {
    const { json } = action.payload;
    const groupingIndex = state.renderData.mainGroupings.findIndex(
      (grouping) => grouping.MainGroupingId == json.MainGroupingId
    );

    const mainGroupings = state.renderData.mainGroupings;

    if (-1 !== groupingIndex) {
      mainGroupings[groupingIndex] = {
        ...mainGroupings[groupingIndex],
        SubjectGroupCount: json.SubjectGroupings.length,
      };
    }

    return {
      ...state,
      renderData: {
        ...state.renderData,
        mainGroupings: mainGroupings,
      },
    };
  },
  [GET_SUBJECT_GROUPINGS_SUCCESS]: (state, action) => {
    const { json } = action.payload;
    return {
      ...state,
      isFetchingSubjectGroupings: false,
      renderData: {
        ...state.renderData,
        subjectGroupings: json,
      },
    };
  },
  [PUT_SUBJECT_GROUPING_SUCCESS]: (state, action) => {
    const { json } = action.payload;
    const subjectGroupingIndex = state.renderData.subjectGroupings.findIndex(
      (subjectGrouping) => subjectGrouping.GroupingId == json.GroupingId
    );

    const subjectGroupings = state.renderData.subjectGroupings;

    if (-1 !== subjectGroupingIndex) {
      subjectGroupings[subjectGroupingIndex] = {
        ...subjectGroupings[subjectGroupingIndex],
        GroupingName: json.GroupingName,
      };
    }

    return {
      ...state,
      renderData: {
        ...state.renderData,
        subjectGroupings: subjectGroupings,
      },
    };
  },
  [PUT_SUBJECT_GROUPING_SUBJECTS_SUCCESS]: (state, action) => {
    const { json, groupingId } = action.payload;
    const subjectGroupingIndex = state.renderData.subjectGroupings.findIndex(
      (subjectGrouping) => subjectGrouping.GroupingId == json.GroupingId
    );

    const subjectGroupings = state.renderData.subjectGroupings;

    if (-1 !== subjectGroupingIndex) {
      subjectGroupings[subjectGroupingIndex] = {
        ...subjectGroupings[subjectGroupingIndex],
        IssueCount: json.Subjects.length,
      };
    }

    return {
      ...state,
      renderData: {
        ...state.renderData,
        subjectGroupings: subjectGroupings,
      },
    };
  },
  [UPDATE_KEYWORDS_DATA]: (state, action) => {
    switch (action.valueType) {
      case "ch": {
        // mark single checkbox as checked
        const { value } = action.payload;
        const { id } = action.location;
        let resultedSelectedArray = [];
        resultedSelectedArray = Array.isArray(value)
          ? [...state.formDataValue.G.keywordRows[id].selected, ...value]
          : [...state.formDataValue.G.keywordRows[id].selected, value];
        return {
          ...state,
          formDataValue: {
            G: {
              ...state.formDataValue.G,
              keywordRows: {
                ...state.formDataValue.G.keywordRows,
                [id]: {
                  ...state.formDataValue.G.keywordRows[id],
                  selected: resultedSelectedArray,
                },
              },
            },
          },
        };
      }
      case "ch_uncheck": {
        // uncheck single checkbox
        const { id } = action.location;
        const { value } = action.payload;
        let resultedSelectedArray =
          state.formDataValue.G.keywordRows[id].selected;
        if (Array.isArray(value)) {
          for (let i = 0; i < value.length; i++) {
            resultedSelectedArray = resultedSelectedArray.filter(function (
              element
            ) {
              return element !== value[i];
            });
          }
        } else {
          const idIndex =
            state.formDataValue.G.keywordRows[id].selected.indexOf(value);
          resultedSelectedArray = [
            ...resultedSelectedArray.slice(0, idIndex),
            ...resultedSelectedArray.slice(idIndex + 1),
          ];
        }
        return {
          ...state,
          formDataValue: {
            G: {
              ...state.formDataValue.G,
              keywordRows: {
                ...state.formDataValue.G.keywordRows,
                [id]: {
                  ...state.formDataValue.G.keywordRows[id],
                  selected: resultedSelectedArray,
                },
              },
            },
          },
        };
      }
      case "textinput": {
        // set text value
        const { id } = action.location;
        const { value, fieldValue } = action.payload;
        return {
          ...state,
          formDataValue: {
            G: {
              ...state.formDataValue.G,
              keywordRows: {
                ...state.formDataValue.G.keywordRows,
                [id]: {
                  ...state.formDataValue.G.keywordRows[id],
                  textValues: {
                    ...state.formDataValue.G.keywordRows[id].textValues,
                    [value]: fieldValue,
                  },
                },
              },
            },
          },
        };
      }
      case "radio":
      case "switch":
      case "select": {
        // radio button template
        const { id } = action.location;
        const { value, fieldValue } = action.payload;
        return {
          ...state,
          formDataValue: {
            G: {
              ...state.formDataValue.G,
              keywordRows: {
                ...state.formDataValue.G.keywordRows,
                [id]: {
                  ...state.formDataValue.G.keywordRows[id],
                  radio: {
                    ...state.formDataValue.G.keywordRows[id].radio,
                    [value]: fieldValue,
                  },
                },
              },
            },
          },
        };
      }
    }
  },
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  errorCode: "",
  isFetchingData: false,
  isFetchingMainGroupings: false,
  renderData: {
    clientSubjects: [],
    groups: [],
    mainGroupings: [],
    subjectGroupings: [],
    selectableSubjectGrouping: [],
  },
  formDataValue: {
    G: {
      selectedGroupSubjectInfo: {
        textValues: matchGroupingRecord({}),
      },
      groupingsType: {
        radio: {
          type: "",
        },
      },
      groupingsCountry: {
        radio: {
          name: "",
        },
      },
      groupingsService: {
        radio: {
          service: "any",
        },
      },
      teams: {
        selected: [],
      },
      coverage: {
        selected: [],
      },
      keywordRows: [],
      searchGroupings: {
        textValues: {
          searchInput: "",
        },
        selected: [],
      },
    },
  },
};

export default function groupingsReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/store/reducers/groupings.js